import React from 'react';
type Tome = {
  number: string;
  title: string;
  weeks: string;
  framework: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'First Glides',
  weeks: 'Weeks 1–9',
  framework: 'The Lane Sort · The Ice Map',
  promise: 'Every new skater gliding, stopping and stroking — with your three lanes set up from day one.',
  badge: 'bg-mint text-rink-deep',
  contents: ['Week 1: fall safely and get up fast', 'Snowplow, T-stop and two-foot hockey stop, by lane', 'The Lane Sort: every skater in the right lane in two minutes', 'Forward stroking, backward swizzles and one-foot balance', '10 warm-up games, from Red Light, Green Light to Freeze Tag', 'Five-minute fillers for when the ice is late']
}, {
  number: '02',
  title: 'Edges & Crossovers',
  weeks: 'Weeks 10–18',
  framework: 'The Edge Ladder · The Crossover Clock',
  promise: 'Clean edges and real power at every level.',
  badge: 'bg-glacier text-rink-deep',
  contents: ['Forward outside and inside edges on a circle', 'Forward and backward crossovers, taught by clock position', 'Power crossovers on a figure-8', 'Change-of-edge serpentines and swing rolls', 'Clock Tag, Snake Line and Crossover Train games', 'Read an edge from the boards in one pass']
}, {
  number: '03',
  title: 'Turns & Footwork',
  weeks: 'Weeks 19–27',
  framework: 'The Turn Triangle · The Pattern Builder',
  promise: 'Three-turns, spirals and step sequences your whole group can skate.',
  badge: 'bg-lilac text-white',
  contents: ['Forward and backward three-turns that start from the shoulders', 'Mohawks for everyone, choctaws and brackets for the advanced lane', 'Spirals with balance and a long line', 'Waltz threes and an 8-count footwork pattern', 'Footwork Dice, Statue Spirals and Rhythm Clap games', 'The fixes for skid, scrape and wobble']
}, {
  number: '04',
  title: 'Jumps & Spins',
  weeks: 'Weeks 28–36',
  framework: 'The Jump Ladder · The Spin Spot',
  promise: 'Step-by-step progressions every lane can climb.',
  badge: 'bg-amber text-amber-ink',
  contents: ['Floor, Hold, Solo, Link: four rungs before any new jump', 'Waltz jump, salchow and toe loop progressions', 'From two-foot spin to upright spin, backspin and sit spin', 'Loop and flip progressions for the advanced lane', "Your group's first jump-and-spin combinations", 'Signs a skater is ready for the next rung']
}, {
  number: '05',
  title: 'The Season Show',
  weeks: 'Weeks 37–44',
  framework: 'The 8-Count Builder · The Formation Grid',
  promise: 'A finished group number where every level shines.',
  badge: 'bg-coral text-white',
  contents: ['Skate on the count: musicality every level can learn', 'Formations for up to 30 skaters, without collisions', 'Pinwheels, intersections, a finale and the bows', 'A featured section for every lane', 'Choose and cut show music by structure and BPM', 'Show-night card with a backup plan if the music fails']
}, {
  number: '06',
  title: 'Programs & Season Close',
  weeks: 'Weeks 45–52',
  framework: 'The Program Map · The Readiness Check',
  promise: 'Test-ready skaters and next season already planned.',
  badge: 'bg-rink text-white',
  contents: ['A mini program every lane can skate start to finish', 'Test-day patterns and the competition warm-up', 'A mock competition in class, with a simple score sheet', 'Recovering from a fall mid-program', 'Season assessment: 20 skills × 3 lanes', "Next season's lanes, goals and first four weeks"]
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-ice" data-id="element-437" data-mp="3vbpaaewahvvn">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-438" data-mp="3c7vo31pzg6bc">
        <div className="text-center" data-id="element-439" data-mp="3c85e2pb12dh1">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber-deep" data-id="element-440" data-mp="37913pvcda9p4">
            The complete season
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold text-rink text-3xl sm:text-5xl" data-id="element-441" data-mp="3lygs54ofe31n">
            Six volumes. <span className="text-glacier-deep" data-id="element-442" data-mp="3uy3jsyrcruhi">Fifty-two lessons.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-443" data-mp="3v06gu2qxanvq">
            Each volume covers about two months of the season, in the order a
            club teaches it, and works on its own: its games, circuits and
            worksheets are all inside.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-444" data-mp="3q7v7wyg4b1t">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col rounded-card border border-ice-dark bg-white p-6 shadow-card" data-id="element-445" data-mp="25jf8l0ui0il2">
              <div className="flex items-center gap-2.5" data-id="element-446" data-mp="l26cyc77h7hz">
                <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-sm font-bold ${tome.badge}`} data-id="element-447" data-mp="q0r1vfh0c4r4">
                  {tome.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-ink-muted" data-id="element-448" data-mp="g9d69is6fp39">
                  Volume {tome.number} · {tome.weeks}
                </span>
              </div>
              <h3 className="mt-3 font-display text-2xl font-bold leading-snug text-rink" data-id="element-449" data-mp="6d9z1yigx09g">
                {tome.title}
              </h3>
              <p className="mt-1 text-[12px] font-semibold uppercase tracking-wider text-amber-deep" data-id="element-450" data-mp="3okg1ypftw9p5">
                {tome.framework}
              </p>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-451" data-mp="1ms1qo97si3hp">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-452" data-mp="1rqcykeeiy3xa">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-453" data-mp="1q9fm9yh6hwc3">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-glacier-deep" data-id="element-454" data-mp="1l9bfj062ofz2" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}